import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import CECustomizationButton from './CECustomizationButton.jsx';

const mountCustomizationButtons = () => {
  const elements = document.querySelectorAll('.customization-button-react');

  if (!elements.length) return;

  elements.forEach((element) => {
    if (!element || element.dataset.reactMounted === 'true') return;
    element.dataset.reactMounted = 'true';

    const language = element.getAttribute('data-language') || 'it';
    const ariaControls = element.getAttribute('data-aria-controls') || 'product-customization-drawer-pdp';
    const storeName = element.getAttribute('data-store-name') || 'shared';

    createRoot(element).render(
      <StrictMode>
        <CECustomizationButton language={language} ariaControls={ariaControls} storeName={storeName} />
      </StrictMode>,
    );
  });
};

mountCustomizationButtons();
